import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Mail, MapPin, Store } from 'lucide-react';
import { useAppData } from '@/context/AppDataContext';

// Nova logo Carvalho Achados
const LOGO_URL = "https://customer-assets.emergentagent.com/job_instant-site-pass/artifacts/oznhzql0_image.png";

export const Footer = ({ settings }) => {
  const currentYear = new Date().getFullYear();
  
  // Usa o contexto global para blogCount em vez de fazer fetch próprio
  const { blogCount } = useAppData();
  
  const email = settings?.email_contact || 'carvalhocomercio7@gmail.com';
  const instagramUrl = settings?.instagram_url || 'https://www.instagram.com/carvalhoachados/';
  const whatsappUrl = settings?.whatsapp_channel_link || 'https://whatsapp.com/channel/0029Vb7oBZaKbYMPWBZkWb2i';
  const shopeeUrl = settings?.shopee_url || 'https://collshp.com/carvalhocomercio?view=storefront';

  return (
    <footer className="bg-[#070d17] text-white" data-testid="footer">
      <div className="container mx-auto px-4 max-w-7xl">
        <div className="py-12 md:py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="lg:col-span-1">
            <img
              src={LOGO_URL}
              alt="Carvalho Comercio"
              className="h-12 w-auto object-contain mb-4 bg-white rounded-lg p-2"
            />
            <p className="text-slate-400 text-sm leading-relaxed mb-4">
              Os melhores achadinhos da internet em um so lugar. Promocoes atualizadas diariamente das maiores plataformas.
            </p>
            <div className="flex items-center gap-3">
              <a href={instagramUrl} target="_blank" rel="noopener noreferrer" className="p-2 bg-slate-800 rounded-lg hover:bg-[#E4405F] transition-colors" aria-label="Instagram" data-testid="footer-instagram">
                <Instagram className="w-5 h-5" />
              </a>
              <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className="p-2 bg-slate-800 rounded-lg hover:bg-[#25D366] transition-colors" aria-label="WhatsApp" data-testid="footer-whatsapp-icon">
                <svg viewBox="0 0 24 24" className="w-5 h-5 fill-current"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>
              </a>
              <a href={shopeeUrl} target="_blank" rel="noopener noreferrer" className="p-2 bg-slate-800 rounded-lg hover:bg-[#EE4D2D] transition-colors" aria-label="Shopee" data-testid="footer-shopee-icon">
                <Store className="w-5 h-5" />
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-lg mb-4">Navegacao</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-slate-400 hover:text-orange-400 transition-colors text-sm">Inicio</Link></li>
              <li><Link to="/ofertas" className="text-slate-400 hover:text-orange-400 transition-colors text-sm">Ofertas</Link></li>
              <li><Link to="/virais" className="text-slate-400 hover:text-orange-400 transition-colors text-sm">Virais</Link></li>
              <li><Link to="/categorias" className="text-slate-400 hover:text-orange-400 transition-colors text-sm">Categorias</Link></li>
              {blogCount > 0 && (
                <li><Link to="/blog" className="text-slate-400 hover:text-orange-400 transition-colors text-sm">Blog</Link></li>
              )}
              <li><Link to="/favoritos" className="text-slate-400 hover:text-orange-400 transition-colors text-sm">Favoritos</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-lg mb-4">Legal</h4>
            <ul className="space-y-2">
              <li><Link to="/privacidade" className="text-slate-400 hover:text-orange-400 transition-colors text-sm">Politica de Privacidade</Link></li>
              <li><Link to="/termos" className="text-slate-400 hover:text-orange-400 transition-colors text-sm">Termos de Uso</Link></li>
            </ul>
            <h4 className="font-heading font-semibold text-lg mt-6 mb-4">Nossas Redes</h4>
            <ul className="space-y-2">
              <li>
                <a
                  href={shopeeUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-1.5 text-[#EE4D2D] hover:text-[#FF6B4A] transition-colors text-sm font-medium"
                  data-testid="footer-shopee-link"
                >
                  <Store className="w-4 h-4" />
                  Vitrine Shopee
                </a>
              </li>
              <li>
                <a
                  href={whatsappUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-1.5 text-[#25D366] hover:text-[#2EE67A] transition-colors text-sm font-medium"
                  data-testid="footer-whatsapp-link"
                >
                  <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>
                  Canal WhatsApp
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-lg mb-4">Contato</h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-2 text-slate-400 text-sm">
                <Mail className="w-4 h-4 text-orange-400" />
                <a href={`mailto:${email}`} className="hover:text-orange-400 transition-colors">{email}</a>
              </li>
              <li className="flex items-start gap-2 text-slate-400 text-sm">
                <MapPin className="w-4 h-4 mt-0.5 text-orange-400" />
                <span>Brasil</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="py-4 border-t border-slate-800/60">
          <p className="text-slate-500 text-xs text-center leading-relaxed">
            <strong className="text-slate-400">Aviso de Afiliado:</strong> Este site contem links de afiliados. Ao clicar em um link e fazer uma compra,
            podemos receber uma comissao sem custo adicional para voce. Isso nos ajuda a manter o site funcionando e continuar
            trazendo as melhores ofertas.
          </p>
        </div>

        <div className="py-4 border-t border-slate-800/60">
          <p className="text-slate-500 text-xs text-center">
            &copy; {currentYear} Carvalho Comercio. Todos os direitos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
